module.exports = __webpack_public_path__ + "static/media/BSC_w_pancake.a272c1e3.png";